(function fetchLocationData() {
  const FEATURE = { name: 'consent-tracking-api', version: '0.1' };
  const STORAGE_KEY = 'GeoData';
  const CACHE_DURATION = 60 * 60 * 1000;

  Shopify.loadFeatures([FEATURE], err => {
    if (err) {
      console.error(`Failed to load ${FEATURE.name}:`, err);
      return;
    }

    const code = Shopify.customerPrivacy.getRegion(); 
    if (!code) {
      console.log('Region cannot be determined');
      return;
    }

    const now = Date.now();
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      try {
        const { country, region, time } = JSON.parse(stored);
        if (now - time < CACHE_DURATION) {
          // Cache hit → log and bail out
          console.log(`Current region: ${country}` + (region ? `, ${region}` : ''));
          return;
        }
      } catch {
        console.warn('Failed to parse cached GeoData, proceeding with fresh fetch.');
      }
    }

    const countryCode = code.slice(0, 2);
    const subdivCode = code.slice(2);

    const dn = new Intl.DisplayNames(['en'], { type: 'region' });

    const resolveName = (key) => {
      try {
        return dn.of(key);
      }
      catch {
        return key;
      }
    };

    const country = resolveName(countryCode);
    const region = subdivCode ? resolveName(`${subdivCode}`) : '';

    const payload = { country, region, time: now };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    window.dispatchEvent(new CustomEvent('GeoDataUpdated', { detail: payload }));
  });
})();
